e4.impersonation = {
    init: function () {
        if ( jQuery( '.js-e-extranet-impersonateable-users' ).length === 1 ) {
            e4.util.require.js( e4.settings.require.handlebars, function () {
                e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-extranet-impersonateable-users' );
                e4.impersonation.bindEvents();
                e4.impersonation.load();
            } );
        }
    },
    bindEvents: function () {
        jQuery( '.js-e-extranet-impersonateable-users-search-form' ).on( 'submit', function ( event ) {
            event.preventDefault();
        } );
        jQuery( '.js-e-extranet-impersonateable-users-search-input' ).on( 'keyup input', function ( event ) {
            e4.impersonation.toggleInputGroupState( this );
            e4.impersonation.getUsers( this );
        } );
        jQuery( '.js-e-extranet-impersonateable-users-search-clear' ).on( 'click', function () {
            e4.impersonation.clearInput( this );
        } );
    },
    toggleInputGroupState: function ( domElm ) {
        var jSearchInputGroup = jQuery( domElm ).closest( '.js-e-extranet-impersonateable-users-search-input-group' );
        if ( domElm.value === '' ) {
            jSearchInputGroup.addClass( 'is-empty' );
        }
        else {
            jSearchInputGroup.removeClass( 'is-empty' );
        }
    },
    clearInput: function ( domElm ) {
        jQuery( domElm ).closest( '.js-e-extranet-impersonateable-users-search-input-group' ).find( '.js-e-extranet-impersonateable-users-search-input' ).val( '' ).trigger( 'focus' ).triggerHandler( 'keyup' );
        sessionStorage.removeItem( 'e4.impersonation.search.query' );
    }, //    jqXHR: null,
    ajax: function ( objAjaxSettings, fnCallback ) {
        if ( this.jqXHR !== undefined && this.jqXHR.readyState !== 4 ) {
            this.jqXHR.abort();
        }
        this.jqXHR = jQuery.ajax( jQuery.extend( {
            url: '/system/data/users-impersonateable', // e4.settings.user.impersonation.url,
            method: 'GET',
            dataType: 'json',
            cache: false
        }, objAjaxSettings ) );
        this.jqXHR.done( function ( data ) {
            if ( typeof fnCallback === 'function' ) {
                fnCallback( data );
            }
        } );
    },
    load: function () {
        var jInput   = jQuery( '.js-e-extranet-impersonateable-users-search-input' ),
            strQuery = sessionStorage.getItem( 'e4.impersonation.search.query' );
        if ( strQuery !== null ) {
            jInput.val( strQuery )
            e4.impersonation.toggleInputGroupState( jInput.get( 0 ) );
        }
        e4.impersonation.ajax( {
            data: jInput.closest( 'form' ).serialize()
        }, function ( data ) {
            e4.impersonation.update( data );
            e4.loading.resolveWait( '.js-e-extranet-impersonateable-users' );
        } );
    },
    timeout: null,
    getUsers: function ( domElm ) {
        if ( e4.impersonation.timeout !== null ) {
            clearTimeout( e4.impersonation.timeout );
        }
        e4.impersonation.timeout = setTimeout( function () {
            e4.impersonation.ajax( {
                data: jQuery( domElm.form ).serialize()
            }, function ( data ) {
                e4.impersonation.update( data );
            } );
        }, Math.round( Math.max( e4.settings.search.delay.min, e4.settings.search.delay.max / domElm.value.length ) ) );
    },
    update: function ( data ) {
        sessionStorage.setItem( 'e4.impersonation.search.query', data.q );
        jQuery( '.js-e-extranet-impersonateable-users' ).html( e4.handlebars.tmpl.extranetImpersonateableUsers( data ) );
        e4.loading.resolveWait( '.js-e-extranet-impersonateable-users' );
    }
};

